/* @Author: 李文 
 * @Last Modified by:   李文  */
import React from 'react';
import { Input, Select, Radio, Table, Pagination, Spin, Empty, Button, Modal } from 'antd';
import * as Actions from '../../../actions/bussinessStatistics';
import moment from 'moment';
import './otherStatitics.scss';
import Scrollbars from 'react-custom-scrollbars';

const { Search } = Input;
const { Option } = Select;
const { confirm } = Modal;

const date = {
    'month': [moment().startOf('month').valueOf(), moment().endOf('month').valueOf()],
    'quarter': [moment().startOf('quarter').valueOf(), moment().endOf('quarter').valueOf()],
    'year': [moment().startOf('year').valueOf(), moment().endOf('year').valueOf()],
    'all': []
};
class OtherStatistics extends React.Component{
    constructor(props){
        super(props);
        this.state={
            sortSelectList:[],
            sort: [],
            queryType: 'all',
            type:this.props.type,
            current: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            list: [],
            queryStr:'',
            visible: false,
            mediaTypeList:[
                {
                    value: '',
                    label: '全部类型'
                },
                {
                    value: '1',
                    label: '网站'
                },
                {
                    value: '2',
                    label: '公众号'
                },
                {
                    value: '3',
                    label: '微博'
                },
                {
                    value: '5',
                    label: '抖音'
                },
                {
                    value: '6',
                    label: '其他媒体'
                }
            ],
            mediaType:'',
            mediaList:[],//媒体名称列表
            mediaName:'',
            
        }
    }

    componentDidMount(){
        this.getSortSelectList();
        this.getList();
        this.mediaTypeChange('')
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.type !== this.props.type){
            this.getSortSelectList(nextProps.type);
            this.state.queryStr='';
            this.setState({
                type: nextProps.type,
                sort: [],
                queryType: 'all',
                current: 1,
                pageSize: 10,
                total: 0,
                list: [],
                loading: false,
                sortSelectList:[],
            }, ()=> {
                this.getSortSelectList();
                this.getList();
                this.mediaTypeChange('')
            })
        }
    }

    getSortSelectList = () => {
        const { type } = this.state;
      //  console.log(type)
        let sortSelectList = [
            {
                value: '1',
                label: '按稿件发布数量排序'
            },
            {
                value: '2',
                label: '按稿件提交数量排序'
            },
           /* {
                value: '4',
                label: '按线索采用数量排序'
            },
            {
                value: '5',
                label: '按线索提交数量排序'
            },*/
        ];
        if(type === 'reporter'){
            sortSelectList=[
                {
                    value: 'completeNum',
                    label: '按任务完成数量排序'
                },
                {
                    value: 'assignNum',
                    label: '按任务分派数量排序'
                }, {
                    value: 'publishStoryNum',
                    label: '按发布稿件数量排序'
                },
                {
                    value: 'subStoryNum',
                    label: '按提交稿件数量排序'
                }, {
                    value: 'publishPicNum',
                    label: '按发布图片数量排序'
                },
                {
                    value: 'subPicNum',
                    label: '按提交图片数量排序'
                }, {
                    value: 'publishVideo',
                    label: '按发布视频数量排序'
                },
                {
                    value: 'subVideo',
                    label: '按提交视频数量排序'
                }, {
                    value: 'publishFile',
                    label: '按发布附件数量排序'
                },
                {
                    value: 'subFile',
                    label: '按提交附件数量排序'
                }
            ]

        }
        if( type === 'topic'){
            sortSelectList = [
                {
                    value: '1',
                    label: '按报送选题数量排序'
                },
                {
                    value: '2',
                    label: '按被采用选题数量排序'
                },
                {
                    value: '3',
                    label: '按审核选题数量排序'
                },
                {
                    value: '4',
                    label: '按分派选题数量排序'
                }
            ]
        }
        if( type === 'edit' ){
            sortSelectList = [ {
                value: 'count',
                label: '按总发布数排序'
               },
                {
                    value: 'interviewStoryNum',
                    label: '按任务稿件发布数排序'
                },
                {
                    value: 'subStoryNum',
                    label: '按投稿稿件发布数排序'
                },
                {
                    value: 'originalStoryNum',
                    label: '按原创稿件发布数排序'
                },
                {
                    value: 'storyNum',
                    label: '按普通稿件发布数排序'
                },
            ]
        }

        this.setState({
            sortSelectList,
        })
    }
    
    handleChange = (value) => {

        this.setState({
            sort: value,
            current: 1
        }, () => {
            this.getList()
        })
    }

    mediaTypeChange(value){
        //更新媒体状态
        this.state.current = 1;
        this.state.mediaType=value;
        //媒体变更时媒体联动
        let params={type:value};
        this.state.mediaName='';
        Actions.getMediaName(params,res=>{
            let mediaList=[];
            if(res){
                mediaList=  res;
            }
            this.setState({mediaList})

        });
        this.setState({mediaType:value}, () => {
            this.getList()
        })
    }

    //记者媒体名称变更
    mediaNameChange(value){
        this.setState({mediaName:value}, () => {
            this.getList()
        })
    }

    changeType = (e) => {
        this.setState({
            queryType: e.target.value,
            current: 1
        }, () => {
            this.getList()
        })
    }

    getDeptColumns = () => {
        const columns = [
           /* {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                render: (text, record, index) => <span>{(index + 1) + (this.state.current - 1) * (this.state.pageSize)}</span>
            },*/
            {
                title: '部门名称',
                dataIndex: 'deptName',
                key: 'deptName'
            },
            {
                title: '已发布 / 已提交 【稿件数量】',
                dataIndex: 'storyStatics',
                key: 'storyStatics'

            },
           /* {
                title: '已采用 / 已提交 【线索数量】',
                dataIndex: 'newsclueStatics',
                key: 'newsclueStatics'
            }*/
        ]
        return columns
    }

    getReportColumn = () => {
        const columns = [
           /* {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                render: (text, record, index) => <span>{(index + 1) + (this.state.current - 1) * (this.state.pageSize)}</span>
            },*/
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: '已完成 / 已分派 【任务数量】',
                dataIndex: 'interviewStatics',
                key: 'interviewStatics',
                render: (text, record, index) =>{
                    return(<span>
                        {record.completeNum+'/'+record.assignNum}
                    </span>)
                }

            },
            {
                title: '已发布 / 已提交 【稿件数量】',
                dataIndex: 'publishStoryNum',
                key: 'publishStoryNum',
                render: (text, record, index) =>{
                    return(<span>
                        {record.publishStoryNum+'/'+record.subStoryNum}
                    </span>)
                }

            },
            {
                title: '已发布 / 已提交 【图片数量】',
                dataIndex: 'publishPicNum',
                key: 'publishPicNum',
                render: (text, record, index) =>{
                    return(<span>
                        {record.publishPicNum+'/'+record.subPicNum}
                    </span>)
                }
            },
            {
                title: '已发布 / 已提交 【视频数量】',
                dataIndex: 'publishVideo',
                key: 'publishVideo',
                render: (text, record, index) =>{
                    return(<span>
                        {record.publishVideo+'/'+record.subVideo}
                    </span>)
                }
            },
            {
                title: '已发布 / 已提交 【附件数量】',
                dataIndex: 'newsclueStatics',
                key: 'newsclueStatics',
                render: (text, record, index) =>{
                    return(<span>
                        {record.publishFile+'/'+record.subFile}
                    </span>)
                }
            }
        ]
        return columns

    }

    getPersonColumn = () => {
        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                render: (text, record, index) => <span>{(index + 1) + (this.state.current - 1) * (this.state.pageSize)}</span>
            },
            {
                title: '用户姓名',
                dataIndex: 'reportName',
                key: 'reportName'
            },
            {
                title: '部门',
                dataIndex: 'deptName',
                key: 'deptName'
            },
            {
                title: '已发布 / 已提交 【稿件数量】',
                dataIndex: 'storyStatics',
                key: 'storyStatics'

            },
            {
                title: '已采用 / 已提交 【线索数量】',
                dataIndex: 'newsclueStatics',
                key: 'newsclueStatics'
            }
        ]
        return columns

    }

    getTopicColumn = () => {
        const columns = [
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: '报送选题',
                dataIndex: 'cjTs',
                key: 'cjTs'
            },
            {
                title: '被采用选题',
                dataIndex: 'bcyTs',
                key: 'bcyTs'

            },
            {
                title: '审核选题',
                dataIndex: 'shTs',
                key: 'shTs'
            },
            {
                title: '分派选题',
                dataIndex: 'fpTs',
                key: 'fpTs'
            }
        ]
        return columns
    }

    getEditColumn = () => {
        const columns = [
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: '媒体名称',
                dataIndex: 'mediaName',
                key: 'mediaName'
            },
            {
                title: '媒体类型',
                dataIndex: 'mediaType',
                key: 'mediaType',
                render: (text, record, index) =>{
                    let title;
                    this.state.mediaTypeList.forEach(item=>{
                        if(record.mediaType==item.value){
                            text=item.label;
                        }
                    })
                    return(
                        <span>{text}</span>
                        )
                }
            },
            {
                title: '总发布数',
                dataIndex: 'count',
                key: 'count'
            },
            {
                title: '任务稿件发布数',
                dataIndex: 'interviewStoryNum',
                key: 'interviewStoryNum'
            },
            {
                title: '投稿稿件发布数',
                dataIndex: 'subStoryNum',
                key: 'subStoryNum'
            },
            {
                title: '原创稿件发布数',
                dataIndex: 'originalStoryNum',
                key: 'originalStoryNum'
            },
            {
                title: '普通稿件发布数',
                dataIndex: 'storyNum',
                key: 'storyNum'
            }
        ]
        return columns

    }

    changePage = (current) => {
        this.setState({
            current
        }, () => {
            this.getList()
        })
    }

    changeQueryStr = (e) => {
        this.setState({
            queryStr: e.target.value
        })
    }

    getParams = () => {
        let params = {}
        switch(this.state.sort) {
			case "1":
				params.rank = "use";
				params.category = "story";
				return params
			case "2":
				params.rank = "all";
				params.category = "story";
				return params
			// case "3":
			// 	rank = "rate";
			// 	category = "story";
			// 	break;
			case "4":
				params.rank = "use";
				params.category = "newsclue";
				return params
			case "5":
				params.rank = "all";
				params.category = "newsclue";
				return params
			// case "6":
			// 	rank = "rate";
			// 	category = "newsclue";
			// 	break;
			case "7":
				params.rank = "use";
				params.category = "interview";
				return params
			case "8":
				params.rank = "all";
				params.category = "interview";
				return params
			// case "9":
			// 	rank = "rate";
			// 	category = "interview";
			// 	break;
			default:
				params.rank = "use";
                params.category = "story";
                return params
		}

    }
    resetList=()=>{
        this.setState({
            sort:'',
            current: 1,
            mediaType:'',
            mediaName:''
        }, () => {
            this.getList()
        })
    }

    getList = () => {
        let otherParams = this.getParams();
        console.log(otherParams)
        const { current, pageSize, queryStr, type, queryType,sort,mediaType,mediaName } = this.state;
        let params = { start: current, size: pageSize, queryStr, type:queryType, ...otherParams  };
        this.setState({
            //loading: true
        }, () => {
            if(type === 'dept'){
                Actions.getDeptStaticsNew(params, (res) => {
                    let list=[];
                    if( res.data&& res.data.length>0){
                        res.data.forEach((item,index)=>{
                            item.key=index
                        })
                        list=res.data
                    }
                    this.setState({
                        loading: false,
                        total: res.count,
                        list: list
                    })
                })
            }
            if(type === 'reporter'){
                let sDate = date[queryType][0] ? date[queryType][0] : '';
                let eDate = date[queryType][1] ? date[queryType][1] : '';
                params={
                    start: current,
                    size: pageSize,
                    name: queryStr,
                    sDate,
                    eDate,
                    orderCondition:sort,
                };
                Actions.getInterviewTotal(params, (res) => {
                    let list=[];
                    if( res.data&& res.data.length>0){
                        res.data.forEach((item,index)=>{
                            item.key=index
                        })
                        list=res.data
                    }
                    this.setState({
                        loading: false,
                        total: res.count,
                        list: list
                    })
                })
            }
            if(type === 'person'){
                Actions.getPersonStaticsNew(params, (res) => {
                    let list=[];
                    if( res.data&& res.data.length>0){
                        res.data.forEach((item,index)=>{
                            item.key=index
                        })
                        list=res.data
                    }
                    this.setState({
                        loading: false,
                        total: res.count,
                        list: list
                    })
                })
            }
            if(type === 'topic'){
                let sDate = date[queryType][0] ? date[queryType][0] : '';
                let eDate = date[queryType][1] ? date[queryType][1] : '';
                params = { orderCondition: sort, start: current, size: pageSize, name: queryStr, sDate, eDate  }
                Actions.getTopic(params, (res) => {
                    let list=[];
                    if( res.data&& res.data.length>0){
                        res.data.forEach((item,index)=>{
                            item.key=index
                        });
                        list=res.data
                    }
                    this.setState({
                        loading: false,
                        total: res.count,
                        list: list
                    })
                })
            }
            if(type === 'edit'){
                let sDate = date[queryType][0] ? date[queryType][0] : '';
                let eDate = date[queryType][1] ? date[queryType][1] : '';
                params={
                    start: current,
                    size: pageSize,
                    name: queryStr,
                    sDate,
                    eDate,
                    orderCondition:sort,
                    mediaType:mediaType,
                    mediaName:mediaName
                };
                 Actions.getMediaPublishNum(params, (res) => {
                     let list=[];
                     if( res.data&& res.data.length>0){
                         res.data.forEach((item,index)=>{
                             item.key=index
                         });
                         list=res.data
                     }
                    this.setState({
                         loading: false,
                         total: res.count,
                         list: list
                     })
                 })
            }

        })
    }

    clickExport = () => {
        this.setState({
            visible:true
        })
    }

    export = () => {
        let params = this.getParams()
        const { sortSelectList, sort, queryType, type, current, pageSize, total, loading, list, queryStr, visible ,mediaName,mediaList,mediaTypeList,mediaType} = this.state;
        let sDate = date[queryType][0] ? date[queryType][0] : '';
        let eDate = date[queryType][1] ? date[queryType][1] : '';
        if(this.state.type==="dept"){
            //interview/exportInterviewPublishNum  GET  入参 name名字筛选,startDate,endDate,orderCondition排序字段
            window.location.href="/cm-sites-pms/reporter/exportDeptStaticsNew?name="+queryStr+'&startDate='+sDate+'&endDate='+eDate+'&orderCondition='+sort+'&type='+queryType
        }else if(this.state.type==="reporter"){
            //interview/exportInterviewPublishNum  GET  入参 name名字筛选,startDate,endDate,orderCondition排序字段
            window.location.href="/cm-sites-pms/interview/exportInterviewPublishNum?name="+queryStr+'&startDate='+sDate+'&endDate='+eDate+'&orderCondition='+sort

        }else if(this.state.type==="topic"){
            //topicSelection/exportTopicSelectionNum GET 入参 name名字筛选,orderCondition排序字段,sDate,eDate
            window.location.href="/cm-sites-pms/topicSelection/exportTopicSelectionNum?name="+queryStr+'&startDate='+sDate+'&endDate='+eDate+'&orderCondition='+sort
        }else if(this.state.type==="edit"){
            // media/exportMediaPublishNum  GET 入参 name名字筛选,mediaName媒体名字筛选,mediaType媒体类型筛选,startDate,endDate,orderCondition排序字段
            window.location.href="/cm-sites-pms/media/exportMediaPublishNum?name="+queryStr+'&startDate='+sDate+'&endDate='+eDate+'&orderCondition='+sort+'&mediaName='+mediaName+'&mediaType='+mediaType

        }
        this.setState({
            visible:false
        })
       // window.location.href = "/cm-sites-pms/reporter/exportStatisticData?target="+target+"&type="+this.state.queryType+"&rank="+(params.rank===""?"use":params.rank)+"&category="+(params.category===""?"story":params.category);
    };

    render(){
        const { sortSelectList, sort, queryType, type, current, pageSize, total, loading, list, queryStr, visible ,mediaName,mediaList,mediaTypeList,mediaType} = this.state;
        let columnType = {
            'dept': this.getDeptColumns(),
            'reporter': this.getReportColumn(),
            'person': this.getPersonColumn(),
            'topic': this.getTopicColumn(),
            'edit': this.getEditColumn(),
        };
        return(
            <div className="other-statistics">
               <div className="other-statistics-options">
                   <div className="other-statistics-options-left" style={{ width: type==='edit' ? '1280px' : '720px'}}>
                   <Search
                        placeholder="搜索"
                        enterButton="搜索"
                        value={queryStr}
                        onChange={this.changeQueryStr}
                        onSearch={() => this.setState({ current: 1 }, () => { this.getList() } )}
                        style={{ width: 300 }}
                    />
                       <Select value={sort} style={{ width: 200 }} onChange={this.handleChange} placeholder="请选择排序">
                           {
                               sortSelectList && sortSelectList.length > 0 && sortSelectList.map((item) => (
                                   <Option value={item.value} key={item.value}>{item.label}</Option>
                               ))
                           }
                       </Select>
                    {
                        type !== 'edit' ? null : 
                        <>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span>媒体类型：</span>
                                <Select value={mediaType} style={{ width: 200 }} onChange={(val)=>{this.mediaTypeChange(val)}} placeholder="请选择">
                                    {
                                        mediaTypeList && mediaTypeList.length > 0 && mediaTypeList.map((item) => (
                                            <Option value={item.value} key={item.value}>{item.label}</Option>
                                        ))
                                    }
                                </Select>
                            </div>
                            <div>
                                <div style={{ display: 'flex', alignItems: "center" }}>
                                    <span>媒体名称：</span>
                                    <Select value={mediaName} style={{ width: 200 }} onChange={(val)=>{this.mediaNameChange(val)}} placeholder="请选择">
                                        {
                                            mediaList && mediaList.length > 0 && mediaList.map((item) => (
                                                <Option value={item} key={item}>{item}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                            </div>
                        </>
                    }
                    <Button type="primary" onClick={this.clickExport}>导出表格</Button>
                    <Button type="primary" onClick={this.resetList}>重置</Button>
                   </div>
                    <Radio.Group value={queryType} onChange={this.changeType}>
                        <Radio.Button value="month">本月</Radio.Button>
                        <Radio.Button value="quarter">本季度</Radio.Button>
                        <Radio.Button value="year">本年</Radio.Button>
                        <Radio.Button value="all">总和</Radio.Button>
                    </Radio.Group>   
               </div>
                {
                    loading ? <div className="center"><Spin /></div> : (
                        list && list.length === 0 ? <div className="center"><Empty /></div> :
                            <>
                                <div className="other-statistics-content">
                                    <Scrollbars>
                                        <Table
                                            columns={columnType[this.state.type]}
                                            dataSource={list}
                                            rowKey={(record) => record.key}
                                            locale={{ emptyText: " " }}
                                            pagination={false}
                                        />
                                    </Scrollbars>
                                </div>
                                <div className="other-statistics-footer">
                                    <Pagination
                                        current={current}
                                        pageSize={pageSize}
                                        total={total}
                                        onChange={this.changePage}
                                    />
                                </div>
                            </>
                    )
                }
                <Modal
                    title="导出表格"
                    visible={visible}
                    onOk={this.export}
                    onCancel={() => this.setState({ visible: false })}
                >
                    导出数据包含当前展示的类别、时间维度下的所有数据，并按排序选择进行排序，不受搜索关键词和结果的限制。
               </Modal>   
            </div>
        )
    }
}

export default OtherStatistics